import { useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { PageResult } from '@blesk/contracts';
import { apiGet, type QueryParams } from './api';

export const PER_PAGE = 50;

/**
 * Постраничный список раздела (§13).
 *
 * `placeholderData: keepPreviousData` держит прежнюю страницу на экране,
 * пока грузится новая, — таблица не мигает пустотой при каждом фильтре.
 * Смена фильтров возвращает на первую страницу: прежний номер страницы
 * в новом отборе бессмыслен.
 */
export function usePagedList<T>(resource: string, path: string, filters: QueryParams) {
  const [page, setPage] = useState(1);

  const filterKey = JSON.stringify(filters);
  const [lastFilterKey, setLastFilterKey] = useState(filterKey);
  if (filterKey !== lastFilterKey) {
    setLastFilterKey(filterKey);
    setPage(1);
  }

  const query = useQuery({
    queryKey: [resource, 'list', filterKey, page],
    queryFn: () => apiGet<PageResult<T>>(path, { ...filters, page, perPage: PER_PAGE }),
    placeholderData: keepPreviousData,
  });

  return {
    items: query.data?.items ?? [],
    total: query.data?.total ?? 0,
    page,
    setPage,
    perPage: PER_PAGE,
    isPending: query.isPending,
    isFetching: query.isFetching,
    error: query.error,
  };
}
